// ANGULAR DEPENDENCY
import { Injectable } from '@angular/core';

// NGRX AND RXJS
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

// GLOBAL ACTIONS, SELECTORS AND STATES
import { State } from '../../root-state';
import * as actions from './store/actions';
import * as selectors from './store/selectors';

// COMMON INTERFACES
import { ApiPayload } from '../../../models/common/api/api-payload.interface';
@Injectable()
export class MasterBusinessStoreService {

  constructor(
    protected store: Store<State>,
  ) {
  }

  /************** Dispatchers ************** */

  // -------------------------------
  //  Dispatch Master Busineess common method everytime
  // -------------------------------
  dispatchMasterBusinessCommon(payload: ApiPayload) {
    this.store.dispatch(new actions.MasterBusinessCommonAction(payload));
  }


  /************** Selectors ************** */
    // -------------------------------
  //  Select Stress Profile List
  // -------------------------------
  selectStressProfileList(): Observable<any> {
    return this.store.select(selectors.selectStressProfileList);
  }

      // -------------------------------
  //  Select Stress Profile List
  // -------------------------------
  selectEmployeeRoleList(): Observable<any> {
    return this.store.select(selectors.selectEmployeeRoleList);
  }

      // -------------------------------
  //  Select Master Leave List
  // -------------------------------
  selectMasterLeaveList(): Observable<any> {
    return this.store.select(selectors.selectMasterLeaveList);
  }
}
